export default "//file.bilionpass.com/japandx-web/0.0.1/static/ai-btn.88bf5355-746ec5.svg";